import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { fetchAllTypeaheadPrimarySkill, clearTypeahed } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class PrimarySkillTypeahead extends Component {
    static propTypes = {
        fetchAllTypeaheadPrimarySkill: PropTypes.func.isRequired,
        error: PropTypes.string,
        suggestions: PropTypes.array,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        renderMultiSuggestion: PropTypes.func,
        clearTypeahed: PropTypes.func,
        animatedPlaceholder: PropTypes.bool,
        disabled: PropTypes.bool,
        isRequired: PropTypes.bool
    };

    static defaultProps = {
        suggestions: [],
        renderMultiSuggestion
    };

    state = {
        isLoading: false
    };

    onFocus = async () => {
        this.setState({ isLoading: true });

        try {
            await this.props.fetchAllTypeaheadPrimarySkill(PrimarySkillTypeahead.name);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        const { suggestions,
            value,
            animatedPlaceholder,
            onChangeSuggestion,
            clearTypeahed,
            renderMultiSuggestion,
            error,
            disabled,
            isRequired = false,
            t } = this.props;
        const options = (Array.isArray(suggestions) ? suggestions : []).map(primarySkill => ({
            label: primarySkill.name, value: primarySkill.id
        }));

        return (
            <MultiTypeahead
                options={options}
                isMulti
                isLoading={this.state.isLoading}
                value={value}
                titleId="primarySkill"
                animatedPlaceholder={animatedPlaceholder}
                onChangeSuggestion={onChangeSuggestion}
                handleSuggestionsClearRequested={clearTypeahed}
                onFocus={this.onFocus}
                formatOptionLabel={renderMultiSuggestion}
                error={error}
                disabled={disabled}
                required={isRequired}
                t={t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === PrimarySkillTypeahead.name
            ? typeahead.list
            : PrimarySkillTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchAllTypeaheadPrimarySkill,
    clearTypeahed
})(PrimarySkillTypeahead);
